"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksLineitemMappingUpdate = exports.QuickbooksLineitemMappingCreateArray = exports.QuickbooksLineitemMappingCreate = exports.QuickbooksLineitemMappingArray = exports.QuickbooksLineitemMapping = exports.QuickBooksLineitemMappingType = exports.QuickBooksLineitemMappingTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.QuickBooksLineitemMappingTypes = ['REVENUE_ACCOUNT', 'EXPENSE_ACCOUNT'];
exports.QuickBooksLineitemMappingType = typebox_1.Type.Union(exports.QuickBooksLineitemMappingTypes.map((value) => typebox_1.Type.Literal(value)));
exports.QuickbooksLineitemMapping = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String(),
    internalName: typebox_1.Type.String(),
    externalName: typebox_1.Type.String(),
    taxCodeRef: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountType: exports.QuickBooksLineitemMappingType,
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.QuickbooksLineitemMappingArray = typebox_1.Type.Array(exports.QuickbooksLineitemMapping);
exports.QuickbooksLineitemMappingCreate = typebox_1.Type.Object({
    internalName: typebox_1.Type.String(),
    externalName: typebox_1.Type.String(),
    taxCodeRef: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountType: exports.QuickBooksLineitemMappingType,
});
exports.QuickbooksLineitemMappingCreateArray = typebox_1.Type.Array(exports.QuickbooksLineitemMappingCreate);
exports.QuickbooksLineitemMappingUpdate = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    internalName: typebox_1.Type.Optional(typebox_1.Type.String()),
    externalName: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxCodeRef: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=mapping.js.map